import constants from 'common/helpers/constants'


export const initialState = {
  paymentMethod: constants.paymentMethods.creditCard,
  isShippingFormValid: false,
  inquire: {
    isFetching: true,
    isFetched: false,
    data: {
      subscription: {
        price: 0,
        shipping: null,
        discount: null,
      },
      bill: {
        tax: null,
        price: null,
        shipping: null,
        discount: null,
        upchargePrice: null,
      },
      coupon: {
        code: null,
        offerType: null,
        couponType: null,
        isFetching: false,
        errorMessage: null,
      },
      cart: {},
      subscriptionCasePrice: null,
    },
  },
  bill: {
    items: [],
    total: 0,
  },
  outOfStockProducts: [],
}

export const setPaymentMethod = (state, paymentMethod) => ({ ...state, paymentMethod })

export const setIsShippingValid = (state, isValid) => ({ ...state, isShippingFormValid: isValid })

export const setInquireFetchingStatus = (state, isFetching) => ({
  ...state,
  inquire: {
    ...state.inquire,
    isFetching,
    error: null,
  },
})

export const setInquireAndBillData = (state, { bill, inquireData }) => ({
  ...state,
  inquire: {
    isFetching: false,
    isFetched: true,
    error: null,
    data: inquireData,
  },
  bill,
})

export const setOutOfStockProducts = (state, outOfStockProducts) => ({
  ...state,
  outOfStockProducts,
})

export const removeBillItems = (state) => ({
  ...state,
  bill: {
    ...state.bill,
    items: [],
  },
})

export const update = (state, newState) => newState
